import { render } from "./Original.vue?vue&type=template&id=cd8a7f8a"
import script from "./Original.vue?vue&type=script&lang=js"
export * from "./Original.vue?vue&type=script&lang=js"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__